/* eslint-disable no-param-reassign */
import React from 'react';
import { IconButton } from '@mui/material';
import { colors } from '@roku-web-ui/rds-theme';

import { IconAudio, IconAudioMute } from 'components/icons';
import { Tooltip } from 'components/common/Tooltip';
import { useAspenLogger } from 'hooks/useAspenLogger';
import { dispatchEvent } from 'modules/globalEvents';

import { AppDeviceLeaf } from 'types/common/leaf';

interface SoundProps {
  leafId: AppDeviceLeaf['id'];
  soundEnabled: boolean;
}

export const Sound = ({ leafId, soundEnabled }: SoundProps) => {
  const { logAspenEvent } = useAspenLogger();

  return (
    <Tooltip title={soundEnabled ? 'Mute' : 'Unmute'} placement="top">
      <IconButton
        aria-label="sound"
        data-testid="button-sound"
        onClick={() => {
          dispatchEvent({
            leafId,
            event: 'TOGGLE_SOUND',
            data: { newValue: !soundEnabled },
          });

          logAspenEvent({
            log_id: 'iot.web.stream.interaction',
            payload: {
              device_id: leafId,
              interaction: 'sound',
            },
          });
        }}
        sx={{
          '&:hover': {
            boxShadow: 'none',
          },
        }}
      >
        {soundEnabled ? (
          <IconAudio fontSize="medium" sx={{ color: colors.purple[500] }} />
        ) : (
          <IconAudioMute fontSize="medium" sx={{ color: colors.grey[400] }} />
        )}
      </IconButton>
    </Tooltip>
  );
};
